import { map } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { clientApiService } from '@cbridge-packages/api';
import { INodeForm } from '../node.interface';

export const createNodeHandler = async (node: INodeForm): Promise<number> => {
  const node$ = clientApiService.createNode({ name: node.name }).pipe(
    map((response) => {
      return response.nodeId;
    }),
  );

  return await firstValueFrom(node$);
};
